import { useEffect, useState } from 'react';

import { apiOrchestrator } from 'services/apiService';

export const useUserProfileImage = (userId?: string | null) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    apiOrchestrator
      .get(`/users-person/get-image/${userId}?avatar=true&use_cdn=true`)
      .then(res => {
        setImageUrl(res.data);
      })
      .finally(() => setLoading(false));
  }, [userId]);

  return { imageUrl, loading };
};
